import { useState, FormEvent } from 'react';
import { supabase } from '../lib/supabase';
import { WSLogo, WSHeartMark } from '../components/ui';
import { Icon } from '../components/Icon';

export function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError(error.message);
  }

  return (
    <div className="ws-fadein" style={{
      display: 'grid', gridTemplateColumns: '1fr 1.05fr',
      height: '100vh', width: '100%', background: 'var(--ws-bone)',
    }}>
      {/* LEFT — form */}
      <div className="ws-scroll" style={{
        display: 'flex', flexDirection: 'column', padding: '40px 64px',
        position: 'relative', overflow: 'auto', background: 'var(--ws-paper)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <WSLogo size={28} />
          <a href="https://locate2u.com" style={{ fontSize: 12.5, color: 'var(--ws-mute)', textDecoration: 'none', letterSpacing: '0.04em' }}>
            locate2u.com →
          </a>
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', maxWidth: 420, margin: '0 auto', width: '100%' }}>
          <div style={{ marginBottom: 36 }}>
            <div className="ws-eyebrow-brand" style={{ marginBottom: 14 }}>Reporting Portal · Sign in</div>
            <h1 className="ws-display-thin" style={{ fontSize: 52, margin: '0 0 14px', color: 'var(--ws-ink)' }}>
              Welcome back.
            </h1>
            <div style={{ fontSize: 15, color: 'var(--ws-mute)', lineHeight: 1.55, maxWidth: 380 }}>
              Sign in to your delivery performance dashboard across your Australian distribution network.
            </div>
          </div>

          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 26 }}>
            <div>
              <label className="ws-field-label">Email address</label>
              <input
                type="email"
                required
                className="ws-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoComplete="email"
                placeholder="you@company.com"
              />
            </div>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <label className="ws-field-label">Password</label>
                <a
                  href="#"
                  onClick={async (e) => {
                    e.preventDefault();
                    if (!email) { setError('Enter your email above first.'); return; }
                    const { error } = await supabase.auth.resetPasswordForEmail(email, {
                      redirectTo: `${window.location.origin}/reset-password`,
                    });
                    setError(error ? error.message : 'Check your email for a reset link.');
                  }}
                  style={{ fontSize: 12, color: 'var(--ws-blue)', textDecoration: 'none', fontWeight: 500 }}
                >
                  Forgot?
                </a>
              </div>
              <input
                type="password"
                required
                className="ws-input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: 'var(--ws-ink-2)', cursor: 'pointer', userSelect: 'none' }}>
              <span
                onClick={() => setRemember(!remember)}
                style={{
                  width: 16, height: 16, border: '1px solid var(--ws-line-strong)', borderRadius: 2,
                  background: remember ? 'var(--ws-blue)' : 'transparent',
                  borderColor: remember ? 'var(--ws-blue)' : 'var(--ws-line-strong)',
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  transition: 'all 140ms',
                }}
              >
                {remember && <Icon name="check" size={11} color="var(--ws-white)" strokeWidth={2.5} />}
              </span>
              <span>Keep me signed in on this device</span>
            </label>

            {error && (
              <div style={{
                fontSize: 13, color: 'var(--ws-danger)',
                background: 'rgba(200,50,45,0.06)', padding: '10px 14px', borderRadius: 4,
                border: '1px solid rgba(200,50,45,0.18)',
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              className="ws-btn ws-btn-primary"
              disabled={loading}
              style={{ width: '100%', padding: '15px 22px', marginTop: 4 }}
            >
              {loading ? (
                <>
                  <svg className="ws-spin" width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" strokeDasharray="40" strokeDashoffset="20" />
                  </svg>
                  Signing in…
                </>
              ) : (
                <>Sign in &nbsp;<span style={{ letterSpacing: 0, fontSize: 14 }}>→</span></>
              )}
            </button>

            <div style={{ fontSize: 13, color: 'var(--ws-mute)', textAlign: 'center', marginTop: 2 }}>
              Don't have an account?{' '}
              <a
                href="/signup"
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, '', '/signup');
                  window.dispatchEvent(new PopStateEvent('popstate'));
                }}
                style={{ color: 'var(--ws-blue)', textDecoration: 'none', fontWeight: 500 }}
              >
                Create one
              </a>
            </div>
          </form>
        </div>

        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          fontSize: 11, color: 'var(--ws-mute-2)', letterSpacing: '0.04em', marginTop: 36,
        }}>
          <span>© Locate2u 2026 · Locate Technologies</span>
          <span style={{ display: 'flex', gap: 18 }}>
            <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy</a>
            <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Terms</a>
            <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Status</a>
          </span>
        </div>
      </div>

      {/* RIGHT — branded gradient panel */}
      <div style={{
        position: 'relative', overflow: 'hidden',
        background: 'radial-gradient(120% 120% at 20% 0%, #1c4b82 0%, #12355B 45%, #0c2340 100%)',
        display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 72px',
      }}>
        <WSHeartMark size={64} frontColor="#3B9EFF" backColor="#ffffff" />
        <div style={{ marginTop: 28, color: '#fff', fontSize: 40, fontWeight: 300, lineHeight: 1.15, letterSpacing: '-0.01em' }}>
          Delivery intelligence,<br />simplified.
        </div>
        <div style={{ marginTop: 18, color: 'rgba(255,255,255,0.7)', fontSize: 15, lineHeight: 1.6, maxWidth: 420 }}>
          Track performance, cost and customer experience across your entire delivery network — powered by Locate2u.
        </div>
      </div>
    </div>
  );
}
